import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { COLORS as palette } from "../../../utils/styles/colors";
import Typography from "../../../utils/styles/typography";
import DefaultProfile from "../../../assets/icons/dashboard/icon-defaultProfile.svg";
import PreviousImage from "../../../assets/icons/dashboard/icon-previous.svg";

const HeaderContainer = styled.div`
  width: 100%;
  height: 126px;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  background-color: ${palette.white};
  z-index: 100;
  top: 0px;
`;

const PreviousButton = styled.button`
  background-image: url(${PreviousImage});
  width: 36px;
  height: 36px;
  border: hidden;
  background-color: transparent;
  margin: auto 0px;
`;

const ButtonContainer = styled.div`
  margin: auto 0px;
  display: flex;
  gap: 12px;
  position: relative;
`;

const ButtonCaption = styled.div`
  ${Typography.Heading5}
  color: ${palette.gray};
  margin: auto 0px;
`;

const RightButton = styled.button`
  height: 36px;
  padding: 7px 24px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: justified;
  border-radius: 20px;
  border: 2px solid ${palette.footer};
  color: ${palette.gray};
  background-color: ${palette.footer};
  z-index: 10;
`;

const MobileHeader = (props) => {
  const [profileImg, setProfileImg] = useState(props.profileImg);
  const [newNotiExist, setNewNotiExist] = useState(true);
  const [dropBoxOn, setDropBoxOn] = useState(false);

  useEffect(() => {
    if (!props.profileImg) {
      // 기본 프로필 이미지로 설정
      setProfileImg(DefaultProfile);
    } else {
      setProfileImg(props.profileImg);
    }
  }, [props.profileImg]);

  const signUpOnClick = () => {
    window.location.href = "/signup";
  };

  const logoOnClick = () => {
    window.location.href = "/mypage";
  };

  return (
    <HeaderContainer>
      <PreviousButton />
      <ButtonContainer>
        <ButtonCaption>Already Signed Up?</ButtonCaption>
        <RightButton onClick={signUpOnClick}>Sign In</RightButton>
      </ButtonContainer>
    </HeaderContainer>
  );
};

export default MobileHeader;
